export default __webpack_public_path__ + "static/V-a637219320c026b3a4b53d5012a62b38.png";